// helpers
import { wrapLongLabels } from './utils/helpers';

// styles
import './styles/graphic.scss';

export default function (props, container, isMobile) {
  const {
    colorScale,
    data,
    height,
    initialWidth,
    initialHeight,
    keys,
    margins,
    width,
    xAxis,
    x,
    yAxis,
    y0,
    y1,
  } = props;

  const xTicks = isMobile ? 5 : 10;
  const [min, max] = [-14, 14];

  const legend = container.append('ul')
    .attr('class', 'key')
    .selectAll('li')
    .data(keys)
    .enter()
    .append('li')
    .attr('class', 'key-item');

  legend.append('span')
    .attr('class', 'key-block')
    .style('background-color', d => colorScale(d));

  legend.append('label')
    .text(d => d.replace(/_/g, ' '));

  const svg = container.append('svg')
    .attr('width', initialWidth)
    .attr('height', initialHeight);

  const g = svg.append('g')
    .attr('transform', `translate(${[margins.left, margins.top]})`);

  const yGrid = g.append('g')
    .attr('class', 'y grid ')
    .attr('role', 'presentation')
    .call(yAxis(y0));

  yGrid.selectAll('text')
    .attr('transform', 'translate(-5,0)')
    .call(wrapLongLabels, margins.left);

  g.append('g')
    .attr('class', 'data-shaded')
    .selectAll('g')
    .data(data)
    .enter()
    .append('g')
    .attr('class', 'shaded-bars')
    .attr('transform', d => `translate(${[1, y0(d.Group) - 5]})`)
    .append('rect')
    .attr('class', d => `shaded-${((d.Group).split(' ').join(''))}`)
    .style('fill', '#ddd')
    .style('fill-opacity', 0.4)
    .attr('width', width - 1)
    .attr('height', 37);

  const xGrid2 = g.append('g')
    .attr('class', 'x grid grid2')
    .attr('role', 'presentation')
    .attr('transform', `translate(${[0, -20]})`)
    .call(xAxis(x)
      .ticks(xTicks)
      .tickSize(-height));

  xGrid2.selectAll('text')
    .attr('y', 6)
    .text(d => ((d === 0) ? 0 : `${d / 1000}M`));

  const xGrid = g.append('g')
    .attr('class', 'x grid')
    .attr('role', 'presentation')
    .attr('transform', `translate(${[0, height]})`)
    .call(xAxis(x)
      .ticks(xTicks)
      .tickSize(-height));

  xGrid.selectAll('text')
    .attr('y', 6)
    .text(d => ((d === 0) ? 0 : `${d / 1000}M`));

  const groups = g.append('g')
    .attr('class', 'data')
    .selectAll('g')
    .data(data)
    .enter()
    .append('g')
    .attr('class', 'bars')
    .attr('transform', d => `translate(${[0, y0(d.Group)]})`);

  const bars = groups.selectAll('g')
    .data(d => keys.map(key => ({ key, value: d[key] })))
    .enter().append('g')
    .attr('class', 'bar')
    .attr('transform', d => `translate(${[x(Math.min(0, d.value)), y1(d.key)]})`);

  bars.append('rect')
    .attr('width', d => Math.abs(x(0) - x(d.value)))
    .attr('height', y1.bandwidth())
    .style('fill', d => colorScale(d.key));

  bars.append('text')
    .attr('x', d => (d.value < 0 ? 0 : Math.abs(x(0) - x(d.value))))
    .attr('y', y1.bandwidth() / 2)
    .attr('dx', d => ((d.value < 0 && Math.abs(d.value / min) < 0.85) || (d.value / max > 0.85) ? -5 : 5))
    .attr('dy', '.32em')
    .attr('text-anchor', d => ((d.value < 0 && Math.abs(d.value / min) < 0.85) || (d.value / max > 0.85) ? 'end' : 'start'))
    .text(d => `${Number(d.value).toFixed(1)}%`);

  if (min < 0) {
    g.append('line')
      .attr('x1', x(0))
      .attr('x2', x(0))
      .attr('y2', height)
      .attr('class', 'zero-bar');
  }
}
